import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Formik, Field, Form } from 'formik';

import Loading from 'components/Loading';

import {
  renameQuality,
} from 'actions/storylet';

const DANGEROUS_AND_UNMAINTAINABLE_REGEX = /^(?:(?!([<>.|'&*/\\?:%"+]|(__)|(\s\s))).)*$/; // eslint-disable-line no-useless-escape
const ERROR_MESSAGE = 'Names may not contain the symbols + < > . | \' & * \\ ? : % / ", two underscores/spaces in sequence, or any trailing/starting spaces.';

export class NameableQualityForm extends Component {
  mounted = false

  componentDidMount = () => {
    this.mounted = true;
  }

  componentWillUnmount = () => {
    this.mounted = false;
  }

  handleSubmit = async ({ name }, actions) => {
    const { branchId, dispatch, qualityPossessedId } = this.props;
    await dispatch(renameQuality({
      branchId,
      qualityPossessedId,
      name: name.trim(), // trim before sending
    }));
    if (this.mounted) {
      actions.setSubmitting(false);
    }
  }

  validate = ({ name }) => {
    if (!DANGEROUS_AND_UNMAINTAINABLE_REGEX.test(name)) {
      return { name: ERROR_MESSAGE };
    }
    return {};
  }

  render = () => {
    const {
      qualityName,
    } = this.props;

    return (
      <Formik
        initialValues={{ name: '' }}
        onSubmit={this.handleSubmit}
        validate={this.validate}
        render={({ values, errors, isSubmitting }) => (
          <Form>
            <p>
              Choose a name for your
              {' '}
              <strong>{qualityName}</strong>
            </p>
            <Field
              type="text"
              maxLength="140"
              name="name"
              className={classnames(
                'form__control form__control--has-validation form__control--has-buttons',
                errors.name && 'form__control--invalid',
              )}
              autoComplete="off"
              value={values.name}
            />
            {errors.name && (
              <p className="form__error" style={{ color: '#b11818' }}>
                {errors.name}
              </p>
            )}
            <p className="buttons">
              <button
                className={classnames(
                  'button button--primary',
                  errors.name && 'button--disabled',
                )}
                disabled={isSubmitting || errors.name}
                type="submit"
              >
                {isSubmitting ? <Loading spinner small /> : 'Rename'}
              </button>
            </p>
          </Form>
        )}
      />
    );
  }
}

NameableQualityForm.propTypes = {
  qualityName: PropTypes.string.isRequired,
};

NameableQualityForm.defaultProps = {

};

export default connect()(NameableQualityForm);